var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.routeName === 'cabinet' ? _c('div', {
    attrs: {
      "id": "blast"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goTop($event);
      }
    }
  }), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goTop($event);
      }
    }
  })]) : _vm._e(), _vm.isShownHeader ? _c('application-header', {
    attrs: {
      "merchant": _vm.MERCHANT_INFO
    }
  }) : _vm._e(), _c('router-view'), _c('capusta-info'), _c('capusta-alert'), _c('modal-cabinet-qr-code'), _c('modal-marketplace-categories'), _c('reports-controller'), _c('safe-deal-status-info-controller', {
    attrs: {
      "transaction": _vm.SELECTED_TRANSACTION
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }